import { map, type MapStore } from 'nanostores';
import { EditorDocument, EditorDocuments } from './editor';

/*
  Workspace files are the files for the current project
  The EditorStore contains the files for the current session
*/
export class FilesStore {
  workspaceFiles: MapStore<EditorDocuments> = map({});

  constructor() {
    this.workspaceFiles = map({});
  }

  addWorkspaceFiles(files: EditorDocuments) {
    this.workspaceFiles.set(files);
  }

  addWorkspaceFile(filePath: string, file: EditorDocument) {
    this.workspaceFiles.setKey(filePath, file);
  }

  getWorkspaceFile(filePath: string) {
    return this.workspaceFiles.get()[filePath];
  }

  reset() {
    this.workspaceFiles.set({});
  }
}
